import { Component, inject } from '@angular/core';
import { UflaUser } from '../../service/auth/ufla-user';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ufla-anleitungen-page',
    templateUrl: './anleitungen-page.component.html',
    styleUrls: [
        './anleitungen-page.component.scss',
    ],
    standalone: false,
})
export class AnleitungenPageComponent {
    public uflaUser: UflaUser;
    private readonly route = inject(ActivatedRoute);

    constructor() {
        this.uflaUser = this.route.snapshot.data.profile;
    }
}
